var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_129_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.327,
    height: 66.778,
    viewBox: "0 0 67.327 66.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    d: "M235.865,5.656h-35.79a2.154,2.154,0,0,0-2.154,2.155v15.2l1.557-1.821a4.958,4.958,0,0,1,2.75-1.622v-9.6h31.482V38.1H202.229v-4.71l-.97,1.134a5,5,0,0,1-3.338,1.724v4.007a2.153,2.153,0,0,0,2.154,2.154H211.7l-5.905,26.81a2.228,2.228,0,0,0,4.352.96l6.116-27.77h3.556l6.116,27.77a2.228,2.228,0,1,0,4.352-.96l-5.9-26.81h11.485a2.154,2.154,0,0,0,2.154-2.154V7.811A2.155,2.155,0,0,0,235.865,5.656Z",
    transform: "translate(-170.692 -5.152)",
    fill: "#537cbe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    d: "M191.519,93.811a.831.831,0,0,0-1.079-.469l-12.689,4.479a2.786,2.786,0,0,0-3.816.389l-4.026,4.7-3.57-3.06c.024.253.077.5.077.758v6.644l1.986,1.7a2.787,2.787,0,0,0,3.928-.3l4.793-5.605,3.866-2.262,10.174-5.952A.83.83,0,0,0,191.519,93.811Z",
    transform: "translate(-143.455 -80.725)",
    fill: "#537cbe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    d: "M15.123,105.776H12.732a5.581,5.581,0,0,0-4.464,2.246L.928,114.78a2.785,2.785,0,0,0-.218,3.934L6.7,125.4a2.784,2.784,0,1,0,4.148-3.716l-4.128-4.609,5.863-5.246-3.415,4.639,3.34,3.729a5,5,0,0,1-5.383,8.055s.026,12.885.026,26.684a3.342,3.342,0,0,0,6.684,0V135.017h2.229v19.917a5.526,5.526,0,0,1-.7,2.646,3.3,3.3,0,0,0,2.019.7,3.342,3.342,0,0,0,3.343-3.342c0-13.795,0-8.012,0-43.551A5.607,5.607,0,0,0,15.123,105.776Z",
    transform: "translate(0 -91.498)",
    fill: "#537cbe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    d: "M57.414,14.267a6.261,6.261,0,0,0,5.954,0,6.514,6.514,0,1,0-5.954,0Z",
    transform: "translate(-46.464 -1.995)",
    fill: "#537cbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileLogo3);
export default __webpack_public_path__ + "static/media/tile-logo3.16453a220a7bfb74513fcb8a020373de.svg";
export { ForwardRef as ReactComponent };